import { defineStore } from "pinia";
import { ref } from "vue";
import { useNuxtApp } from "#app";

export const useSeoDataStore = defineStore("seoData", () => {
  const courseTitles = ref([]);
  const articleTitles = ref([]);
  const lessonTitles = ref([]);
  const bookTitles = ref([]);
  const craftTitles = ref([]);
  const stationeryTitles = ref([]);
  const clothingTitles = ref([]);
  const isLoaded = ref(false);

  /**
   * Charge tous les titres SEO pour cours, articles, leçons, livres, crafts, fournitures et vêtements
   */
  const fetchAllSeoTitles = async () => {
    // Ne pas recharger si déjà fait ou en SSR
    if (isLoaded.value || !import.meta.env.SSR) return;

    try {
      //const { $fetch } = useNuxtApp();

      // Appels en parallèle
      const [
        coursesRes,
        articlesRes,
        lessonsRes,
        booksRes,
        craftsRes,
        stationeriesRes,
        clothingsRes,
      ] = await Promise.all([
        $fetch("/api/courses/get-course-titles"),
        $fetch("/api/articles/get-article-titles"),
        $fetch("/api/lessons/get-lesson-titles"),
        $fetch("/api/books/get-published-books"),
        $fetch("/api/crafts/get-craft-titles"),
        $fetch("/api/stationeries/get-stationery-titles"),
        $fetch("/api/clothings/get-clothing-titles"),
      ]);

      // Peuplement des refs si succès
      if (coursesRes.success) courseTitles.value = coursesRes.data || [];
      if (articlesRes.success) articleTitles.value = articlesRes.data || [];
      if (lessonsRes.success) lessonTitles.value = lessonsRes.data || [];
      if (booksRes.success) bookTitles.value = booksRes.data || [];
      if (craftsRes.success) craftTitles.value = craftsRes.data || [];
      if (stationeriesRes.success)
        stationeryTitles.value = stationeriesRes.data || [];
      if (clothingsRes.success) clothingTitles.value = clothingsRes.data || [];

      isLoaded.value = true;
    } catch (err) {
      console.error("Erreur SEO Store :", err);
    }
  };

  return {
    courseTitles,
    articleTitles,
    lessonTitles,
    bookTitles,
    craftTitles,
    stationeryTitles,
    clothingTitles,
    isLoaded,
    fetchAllSeoTitles,
  };
});
